export default __webpack_public_path__ + "static/media/10.62f64870.jpg";